import type { PageProps } from 'gatsby';
import React from 'react';

import { RoleGuard } from '@components/Guards';

import { RoleName } from '@constants/role_name';

import Drilldown from '@views/Clients/Drilldown';

export default function ClientOverviewPage({ params: { id } }: PageProps) {
  return (
    <RoleGuard roles={[RoleName.Admin, RoleName.Curator]}>
      <Drilldown id={id} />
    </RoleGuard>
  );
}
